import { render, staticRenderFns } from "./NewInvoice.vue?vue&type=template&id=054b32ae&"
import script from "./NewInvoice.vue?vue&type=script&lang=js&"
export * from "./NewInvoice.vue?vue&type=script&lang=js&"
import style0 from "./NewInvoice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports